import * as Yup from 'yup';

// Extend Yup.string with a custom .phone() method
Yup.addMethod(Yup.string, 'phone', function (message = 'Invalid phone number') {
    return this.test('phone', message, function (value) {
        const { path, createError } = this;
        if (!value) return true; // Allow empty values (optional)

        // Basic international E.164 phone format check
        const phoneRegex = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

        return phoneRegex.test(value)
            ? true
            : createError({ path, message });
    });
});

export default Yup;
